import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class MySubscriptionsFactory {
  public static isMyPlanActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  public static isAllSubscriptionActive: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
}
